// === Image Utilities ===

import imageManifest from '../generated/image-manifest.json';
import store from '../state/store.js';

const existingImages = new Set(imageManifest);
const imageList = imageManifest.filter(name => !name.endsWith('_beef'));

function hashCode(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash |= 0;
  }
  return hash;
}

function encodePath(name) {
  return name.replace(/ /g, '%20');
}

export function getHeroBackground(item) {
  const rawTitle = (item.content.title || '').trim();
  const safeTitle = rawTitle.replace(/[?':"'‘’]/g, '');
  const isBeef = store.farmProfile?.herdType === 'Beef';

  if (isBeef && existingImages.has(`${safeTitle}_beef`)) {
    return `url('/pictures/${encodePath(safeTitle)}_beef.webp')`;
  }
  if (existingImages.has(safeTitle)) {
    return `url('/pictures/${encodePath(safeTitle)}.webp')`;
  }
  const idx = Math.abs(hashCode(rawTitle)) % imageList.length;
  const fallback = imageList[idx];
  return `url('/pictures/${encodePath(fallback)}.webp')`;
}
